import { createContext } from "react";

const RoleBuilderContext = createContext(null);

export { RoleBuilderContext };
